module.exports = __webpack_public_path__ + "static/media/login-landscape-footer.dc6782d9.svg";